import {
  PUBLIC_COMPANIES,
  PRIVATE_COMPANIES,
} from '../data/directory/topic_classes/topicClassTypes';

// Selectors: NO,CN,TR,CD
// Locators/filters: CC,SN,SR
// You can only use 1 selector at a time for an identifier section

const tickerFullNameString = (tickers) => (
  (tickers
    ?.map(({ full_name: fullName }) => `TR:${fullName}`)
    || []
  ).join(',')
);

// if company have legal entities
// request with every entity id to find at least one with data
const legalEntitiesString = (legalEntities) => (
  (legalEntities
    ?.map(({ legal_entity_id: legalId, legal_entity_type: legalType }) => {
      let searchString = '';

      if (legalId) {
        searchString += `NO:${legalId}`;
      }
      if (legalType) {
        searchString += `${searchString ? '|' : ''}SR:${legalType}`;
      }

      return searchString;
    })
    ?.filter(Boolean) || []
  ).join(',')
);

export const filingsParamGenerate = (topic, type) => {
  let firstPriority = 'tickers';
  if (type === PUBLIC_COMPANIES) {
    firstPriority = 'tickers';
  } else if (type === PRIVATE_COMPANIES) {
    firstPriority = 'legal_entities';
  }

  let companyTicker = '';
  let companyNumber = '';

  const companyTickerFullName = topic.tickers?.filter((f) => f.full_name);
  if (firstPriority === 'tickers') {
    if (companyTickerFullName?.length) {
      companyTicker = tickerFullNameString(companyTickerFullName);
    } else {
      companyNumber = legalEntitiesString(topic.legal_entities);
    }
  }

  if (firstPriority === 'legal_entities') {
    if (topic.legal_entities?.length) {
      companyNumber = legalEntitiesString(topic.legal_entities);
    } else {
      companyTicker = tickerFullNameString(companyTickerFullName);
    }
  }

  const identifier = [];
  if (companyNumber) {
    identifier.push(companyNumber);
  }
  if (companyTicker) {
    identifier.push(companyTicker);
  }

  return identifier.join('|');
};

export const presentationsParamGenerate = (topic) => {
  const companyTickerFullName = topic.tickers?.filter((f) => f.full_name);
  const companyTicker = tickerFullNameString(companyTickerFullName);

  const identifiers = [];
  if (companyTicker) {
    identifiers.push(companyTicker);
  }
  const { name, slug } = topic;
  if (name) {
    identifiers.push([`CN:${name}`]);
  }
  if (slug) {
    identifiers.push([`SL:${slug}`]);
  }

  return identifiers.join('|');
};
